import { useNavigate } from '@tanstack/react-router';
import { FileQuestionIcon } from 'lucide-react';
import { Button, ResultState } from '@opengoal/ui';
import { useTranslation } from 'react-i18next';

export function NotFoundPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <ResultState
        icon={<FileQuestionIcon />}
        title={t('states.notFoundTitle')}
        description={t('states.notFoundSubtitle')}
        action={
          <Button onClick={() => void navigate({ to: '/' })}>{t('states.backToDashboard')}</Button>
        }
      />
    </div>
  );
}
